import { useRouter } from 'next/router';
import { useEffect } from 'react';
import ProjectForm from '~/components/forms/ProjectForm';
import { useAuthData } from '~/hooks/auth/use-auth-data';
import { api } from '~/trpc-extra/api';
import ProjectLoader from '~/components/loader/ProjectLoader';

export default function Default() {
  const { activeOrg, orgMetadata, isLoggedIn } = useAuthData();

  const { data: project, isLoading } = api.project.getDefaultProject.useQuery(
    { teamId: activeOrg?.orgId || '' },
    { enabled: !!activeOrg?.orgId },
  );
  const router = useRouter();

  useEffect(() => {
    // Wait for both project and auth to be fully loaded before routing.
    // orgMetadata is undefined while auth is loading, so we must wait for
    // isLoggedIn to ensure orgMetadata has been resolved (even if it stays undefined
    // for orgs without metadata). Without this gate, new users with
    // defaultViewMode === 'agent' would be routed to Classic before metadata loads.
    if (!project || !isLoggedIn) {
      return;
    }
    const raw = activeOrg?.orgId ? window.localStorage.getItem(`stably-view-mode-org-${activeOrg.orgId}`) : null;
    if (raw === 'agent' || raw === '"agent"' || orgMetadata?.defaultViewMode === 'agent') {
      router.push(`/project/${project.id}/home`).catch(() => undefined);
    } else {
      router.push(`/project/${project.id}`).catch(() => undefined);
    }
  }, [project, router, orgMetadata, isLoggedIn, activeOrg?.orgId]);

  return (
    <div className="m-auto h-full w-11/12">
      {isLoading || project ?
        // We're either loading or waiting to route, so show the loader.
        <div className="flex h-full items-center justify-center">
          <div
            className="animate-pulse"
            style={{ animationDuration: '1s', animationDelay: '1s' }}
          >
            <ProjectLoader delay={0.5} />
          </div>
        </div>
      : <div className="flex flex-col items-start justify-start py-12">
          <div className="mb-2 text-2xl font-bold tracking-wide">Welcome to Stably!</div>
          <div className="text-gray-600 dark:text-gray-300">
            Let&apos;s create your project. There is where your tests will live.
          </div>
          <br />
          <br />
          <ProjectForm />
        </div>
      }
    </div>
  );
}
